export const socialSkeleton = {
  wrapper: {
    mt: {
      mobile: "1.25rem",
      tablet: "unset",
    },
  },
  icon: {
    mx: 1,
    width: "1.5rem",
    height: "1.5rem",
    color: "white.dark",
  },
};
